// store/authStore.js
import { create } from "zustand";
import { getEarthWorkData } from "../api/earthWork";
import { getBannerData } from "../api/banner";
import { deleteProject, getProject, getProjectByID, postProject, postProjectdata } from "../api/project";
import { deletePage, getPage, getPageByID, postData } from "../api/page";

export const usePageStore = create((set, get) => ({
    loading: true,
    emergency: [],
    utilities: [],
    concrete: [],
    earthwork: [],
    getPageById: async (id, pageName) => {
        try {
            set({ loading: true })
            const res = await getPageByID(id, pageName)
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            return false;
        }
    },
    getPageData: async (pageNumber, pageSize, search, field, pageName) => {
        try {
            set({ loading: true });
            const res = await getPage(pageNumber, pageSize, search, field, pageName);
            set({
                loading: false,
            });
            if (pageName == 'emergency')
                set({ emergency: res?.ref })
            else if (pageName == 'utility')
                set({ utilities: res?.ref })
            else if (pageName == 'concrete')
                set({ concrete: res?.ref })
            else if (pageName == 'earthwork')
                set({ earthwork: res?.ref })
            return res;
        } catch (error) {
            console.log("Error in getProjectForProjectPage:", error);
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    postPage: async (formData, id, pageName) => {
        try {
            set({ loading: true });
            const res = await postData(formData, id, pageName);
            set({
                loading: false,
            });
            return res;

        } catch (error) {
            console.log("Error in getProjectForProjectPage:", error);
            return false;
        }
    },
    deletepage: async (id, pageName) => {
        try {
            set({ loading: true })
            const res = await deletePage(id, pageName)
            if (res && pageName == 'emergency') {
                const currentEmergency = get().emergency || [];
                const updatedEmergency = currentEmergency.filter((ele) => ele._id !== id);
                set({ loading: false, emergency: updatedEmergency });
            }
            else if (res && pageName == 'utility') {
                const currentutilities = get().utilities || [];
                const updatedutilities = currentutilities.filter((ele) => ele._id !== id);
                set({ loading: false, utilities: updatedutilities });
            }
            else if (res && pageName == 'concrete') {
                const currentconcrete = get().concrete || [];
                const updatedconcrete = currentconcrete.filter((ele) => ele._id !== id);
                set({ loading: false, concrete: updatedconcrete });
            } 
            else if (res && pageName == 'earthwork') {
                const currentearthwork = get().earthwork || [];
                const updatedearthwork = currentearthwork.filter((ele) => ele._id !== id);
                set({ loading: false, earthwork: updatedearthwork });
            }
        } catch (err) {
            console.log("Internal server error:", err);
            set({ category: null });
            return false;
        }
    },
    postProjectPageData: async (form) => {
        try {
            set({ loading: true })
            const res = await postProjectdata(form)
            set({ loading: false })
        } catch (err) {
            console.log("Internal server error:", err);
            set({ category: null });
            return false;
        }
    },

}));
